import React from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPlus,
  faUndo,
  faPen,
  faTimes,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import styles from "../master.css";
import apiUrl from "../../apiUrlConstant";
import { Redirect, withRouter, Link } from "react-router-dom";
import { clientAccess } from "../../utils/index";
import TaxationTable from "./TaxationTable";
import Popup from "reactjs-popup";
import { PopupMessage } from "../../utils/utils";
import Select from "react-select";

const headers = {
  "Content-Type": "application/json",
  Authorization: "Bearer " + localStorage.getItem("TOKEN"),
};


class List extends React.Component {
  state = {
    url: `${apiUrl.apiUrl.url}/taxation/create`,
    LandlordGroups: [],
    clientList: [],
    rateTypes: [],
    chargeTypes: [],
    isOpen: false,
    redirect: false,
    messsagePopup: false,
    popupContent: "",
    popupalertMessage: false,
    popupMessageContent: '',
    delete: false,
    id: undefined,
    stateSelected: '',
    states: [],
    initialValues: {
      rateTypeId: "",
      rateTypeTitle: "",
      rate_type: "",
      chargeTypeId: "",
      chargeTypeTitle: "",
      charge_type: "",
      fromDate: "",
      toDate: "",
      rate: ""
    },
  };

  constructor(props) {
    super(props);


  }

  componentDidMount() {




    this.setState({
      rateTypes: [{ title: 'CGST' }, { title: 'SGST' }, { title: 'IGST' }, { title: 'TDS' }],
    });
    this.setState({
      chargeTypes: [{ title: 'RENT(Minimum Guarantee)' }, { title: 'Minimum Guarantee Rent or Revenue Share (Higher)' }, { title: 'CAM' }, { title: 'Car Parking' }, { title: "Signage" }, { title: '2 Wheeler Parking' }, { title: 'Marketing Fund' }, { title: 'Storage Rent' }, { title: 'Electricity – All Others' }, { title: 'HVAC – All' }, { title: 'Water – All' }, { 'title': 'Gas – All' }],
    });

    fetch(`${apiUrl.apiUrl.url}/client-group/fetch-list`, { headers })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          LandlordGroups: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });


    fetch(`${apiUrl.apiUrl.url}/states/country-states/1`, {headers})
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          states: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  }

  checkDelete() {
    var self = this;
    axios({
      method: "get",
      url: `${apiUrl.apiUrl.url}/commercial-clause/check-delete?id=${this.state.id}`,
    }).then(function (response) {
      if (!response.data.success) {
        console.log('you cannot delete');
      } else {
        // if (window.confirm("Are You Sure You Want to Delete the item?")) {
        //   axios({
        //     method: "get",
        //     url: `${apiUrl.apiUrl.url}/commercial-clause/delete?id=${self.state.id}`,
        //   }).then(function (response) {
        //     if (!response.data.success) {
        //       alert("Something Went Wrong");
        //     } else {
        //       alert("Data Deleted Successfully");
        //       self.setState({ redirect: true });
        //     }
        //   });
        // }
        self.setState({
          delete: true,
        });
      }
    });
  }

  componentDidUpdate() {
    if (this.props.match.params.id != this.state.id) {
      this.state.id = this.props.match.params.id;
      if (this.props.match.params.id === undefined) {
        this.setState({
          url: `${apiUrl.apiUrl.url}/taxation/create`,
          initialValues: {
            rateTypeId: "",
            rateTypeTitle: "",
            rate_type: "",
            chargeTypeId: "",
            chargeTypeTitle: "",
            charge_type: "",
            fromDate: "",
            toDate: "",
            rate: "",
            stateId: ""
          },
        });
      } else {
        let athis = this;
        axios.get(`${apiUrl.apiUrl.url}/taxation/fetch-taxation?id=${this.props.match.params.id}`).then((response) => {
          let data = response.data;
          athis.setState({
            url: `${apiUrl.apiUrl.url}/taxation/update?id=${athis.props.match.params.id}`,
            initialValues: data.data,
            LandlordGroups: data.LandlordGroups,
            clientList: data.clientList,
            stateSelected: data.data.stateSelected
            //
          });

        }).catch((error) => {});
        
        // fetch(
        //   `${apiUrl.apiUrl.url}/taxation/fetch-taxation?id=${this.props.match.params.id}`
        // )
        //   .then((response) => {
        //     return response.json();
        //   })
        //   .then((data) => {
        //     this.setState({
        //       url: `${apiUrl.apiUrl.url}/taxation/update?id=${this.props.match.params.id}`,
        //       initialValues: data.data,
        //       LandlordGroups: data.LandlordGroups,
        //       clientList: data.clientList,
        //       stateSelected: data.data.stateSelected
        //       //
        //     });
        //     console.log(this.state.initialValues);
        //   })
        //   .catch((error) => {
        //     console.log(error);
        //   });
      }
    }



  }
  redirectAfterSave = () => {
    this.setState({
      redirect: true,
      messsagePopup: false,
      stateSelected: { 'value': '', 'label': '' },
      initialValues: {
        rateTypeId: "",
        rateTypeTitle: "",
        rate_type: "",
        chargeTypeId: "",
        chargeTypeTitle: "",
        charge_type: "",
        fromDate: "",
        toDate: "",
        rate: "",
        stateId: ""
      },
    });
  };

  redirectAfterEdit = () => {
    this.setState({
      redirect: true,
      messsagePopup: false,
      stateSelected: { 'value': '', 'label': '' },
      initialValues: {
        rateTypeId: "",
        rateTypeTitle: "",
        rate_type: "",
        chargeTypeId: "",
        chargeTypeTitle: "",
        charge_type: "",
        fromDate: "",
        toDate: "",
        rate: "",
        stateId: ""
      },
    });
  };

  redirectToDelete = () => {
    this.setState({
      delete: false,
    });
    var self = this;
    axios({
      method: "get",
      url: `${apiUrl.apiUrl.url}/taxation/delete?id=${this.state.id}`,
    }).then(function (response) {
      if (!response.data.success) {
        // alert("Something Went Wrong");
        self.setState({
          popupalertMessage: true,
          popupMessageContent: 'Something Went Wrong',
        });
      } else {
        // alert("Data Deleted Successfully");
        self.setState({
          messsagePopup: true,
          popupContent: 'Data Deleted Successfully'
        });
      }
    });
  };
  redirectToClose = () => {
    this.setState({
      delete: false,
      popupalertMessage: false,
      popupMessageContent: '',
    });
  };


  handleChangeLandlordGroup = (newValue, actionMeta) => {
    console.group("Value Changed", newValue, "actionMeta", actionMeta);

    if (actionMeta == "change_client_group") {
      this.state.initialValues.groupId = newValue.value;
      this.state.initialValues.groupName = newValue.label;

      fetch(`${apiUrl.apiUrl.url}/client/client-list?groupId=` + newValue.value, {headers})
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          this.setState({
            clientList: data,
          });
        })
        .catch((error) => {
          console.log(error);
        });

      console.log("inside", actionMeta);
    } else if (actionMeta == "rate") {
      this.state.initialValues.rateTypeId = newValue.value;
      this.state.initialValues.rateTypeTitle = newValue.value;
      this.state.initialValues.rate_type = newValue.value;
      this.setState({});
    } else if (actionMeta == "charge") {
      this.state.initialValues.chargeTypeId = newValue.value;
      this.state.initialValues.chargeTypeTitle = newValue.label;
      this.state.initialValues.charge_type = newValue.label;
      this.setState({});
    } else {
      this.state.initialValues.clientId = newValue.value;
      this.state.initialValues.clientName = newValue.label;
      this.setState({});
    }
    this.setState({});
    //this.state.initialValues.groupName = newValue.label;

    // this.groupId = newValue;
    // console.log(this.groupId, "ddd");
    // console.log(`action: ${actionMeta}`);
    // console.groupEnd();
  };


  valueChange = (newValue, actionMeta) => {

    //newValue.value = newValue.target.value;
    //newValue.label = newValue.target.value;

    if (actionMeta == "change_state") {
      this.state.initialValues.stateId = newValue.value;
      this.state.initialValues.state_name = newValue.label;

      this.state.stateSelected = {
        value: newValue.value,
        label: newValue.label,
      };

      // this.state.initialValues.cityId = [];
      // this.state.initialValues.cityName = "";

      // this.state.stateSelected = [];
      // this.state.initialValues.stateId = [];
      // for (let i = 0; i < newValue.length; i++) {
      //   this.state.initialValues.stateId.push(newValue[i].value);
      //   this.state.stateSelected.push({
      //     value: newValue[i].value,
      //     label: newValue[i].label,
      //   });
      // }

      //districtList
    }
    this.setState({});
  };


  render() {
    if (this.state.redirect == true) {
      let url = this.props.match;

      this.state.redirect = false;
      return <Redirect push to="/masters/taxation" />;
    }
    return (
      <div className="parentContainer">
        {this.renderForm()}
      </div>
    );
  }

  renderForm() {
    return (
      <>
        <div className="absoluteItemForTopBar">
          <div className="new_breadcrumbs_design">
            <ul className="d-flex align-items-center gap-3 p-0 m-0">
              <li>
                <Link to="/masters">Masters</Link>
              </li>
              <li><FontAwesomeIcon icon={faChevronRight} /></li>
              <li>
                <Link to="/masters/charges-master">Taxation Master</Link>
              </li>
              <li><FontAwesomeIcon icon={faChevronRight} /></li>
              <li>
                <Link to="#">List</Link>
              </li>
            </ul>
          </div>
        </div>

        <Formik
          initialValues={this.state.initialValues}
          enableReinitialize
          onSubmit={(values, actions) => {
            console.log(values, "==", this.state.initialValues);
            values.chargeTypeId = this.state.initialValues.chargeTypeId;
            values.chargeTypeTitle = this.state.initialValues.chargeTypeTitle;

            values.charge_type = this.state.initialValues.chargeTypeTitle;
            values.rateTypeId = this.state.initialValues.rateTypeId;
            values.rateTypeTitle = this.state.initialValues.rateTypeTitle;
            values.rate_type = this.state.initialValues.rateTypeTitle;
            values.stateId = this.state.initialValues.stateId;

            var self = this;
            axios({
              method: "post",
              url: this.state.url,
              data: values,
            }).then(function (response) {
              if (!response.data.success) {
                actions.setSubmitting(false);

                actions.setErrors(response.data);
              } else {
                self.setState({
                  messsagePopup: true,
                  popupContent: 'Data Saved Successfully'
                });
              }
            });
          }}
        >
          {({
            values,

            errors,

            touched,

            handleChange,

            handleBlur,

            handleSubmit,

            isSubmitting,
          }) => (

            <>
              <div className="unitFormContainerNew">
                <Form autoComplete="off" >
                  <div className="newGridSectionParent">
                    <div className="newGridSectionForFormMain">
                      {clientAccess() && (
                        <div className="newGridSectionInner">
                          <label>
                            Client Group <span className="astrik">*</span>
                          </label>
                          <div className="position-relative">
                            <Select
                            className="basic-single custom-select-style"
                            classNamePrefix="custom-select-style-inner"
                              name="clientGroup"
                              onChange={(e) => {
                                this.handleChangeLandlordGroup(e, "change_client_group");
                              }}
                              value={{
                                label: this.state.initialValues.groupName,
                                value: this.state.initialValues.groupId,
                              }}
                              options={this.state.LandlordGroups.map((item) => ({
                                label: item.group_name,
                                value: item.id,
                              }))}
                            />
                            <ErrorMessage name="clientGroup" component="div" className="text-red" />
                          </div>
                        </div>
                      )}
                      {clientAccess() && (
                        <div className="newGridSectionInner">
                          <label>
                            Client Name <span className="astrik">*</span>
                          </label>
                          <div className="position-relative">
                            <Select
                            className="basic-single custom-select-style"
                            classNamePrefix="custom-select-style-inner"
                              name="clientName"
                              onChange={(e) => {
                                this.handleChangeLandlordGroup(e, "change_client_name");
                              }}
                              value={{
                                label: this.state.initialValues.clientName,
                                value: this.state.initialValues.clientId,
                              }}
                              options={this.state.clientList.map((item) => ({
                                label: item.client_name,
                                value: item.id,
                              }))}
                            />
                            <ErrorMessage name="clientName" component="div" className="text-red" />
                          </div>
                        </div>
                      )}
                      <div className="newGridSectionInner">
                        <label>
                          Rate Type <span className="astrik">*</span>
                        </label>
                        <div className="position-relative">
                          <Select
                            className="basic-single custom-select-style"
                            classNamePrefix="custom-select-style-inner"
                            name="rate_type"
                            onChange={(e) => {
                              this.handleChangeLandlordGroup(e, "rate");
                            }}
                            value={{
                              label: this.state.initialValues.rateTypeTitle,
                              value: this.state.initialValues.rateTypeId,
                            }}
                            options={this.state.rateTypes.map((item) => ({
                              label: item.title,
                              value: item.title,
                            }))}
                          />
                          <ErrorMessage name="rate_type" component="div" className="text-red" />
                        </div>
                      </div>
                      <div className="newGridSectionInner">
                        <label>
                          Charge Type<span className="astrik">*</span>
                        </label>
                        <div className="position-relative">
                          <Select
                            className="basic-single custom-select-style"
                            classNamePrefix="custom-select-style-inner"
                            name="charge_type"
                            onChange={(e) => {
                              this.handleChangeLandlordGroup(e, "charge");
                            }}
                            value={{
                              label: this.state.initialValues.chargeTypeTitle,
                              value: this.state.initialValues.chargeTypeId,
                            }}
                            options={this.state.chargeTypes.map((item) => ({
                              label: item.title,
                              value: item.title,
                            }))}
                          />
                          <ErrorMessage name="charge_type" component="div" className="text-red" />
                        </div>
                      </div>
                      <div className="newGridSectionInner">
                        <label>
                          From Date <span className="astrik">*</span>
                        </label>
                        <div className="position-relative">
                          <Field type="date" name="from_date" />
                          <ErrorMessage name="from_date" component="div" className="text-red" />
                        </div>
                      </div>
                      <div className="newGridSectionInner">
                        <label>
                          To Date <span className="astrik">*</span>
                        </label>
                        <div className="position-relative">
                          <Field type="date" name="to_date" />
                          <ErrorMessage name="to_date" component="div" className="text-red" />
                        </div>
                      </div>
                      <div className="newGridSectionInner">
                        <label>
                          Rate <span className="astrik">*</span>
                        </label>
                        <div className="position-relative">
                          <Field type="text" name="rate" />
                          <ErrorMessage name="rate" component="div" className="text-red" />
                        </div>
                      </div>
                      <div className="newGridSectionInner">
                        <label>
                          State
                        </label>
                        <div className="position-relative">
                          <Select
                            className="basic-single custom-select-style"
                            classNamePrefix="custom-select-style-inner"
                            name="stateId"
                            onChange={(e) => {
                              this.valueChange(e, "change_state");
                            }}
                            value={this.state.stateSelected}
                            options={this.state.states.map((item) => ({
                              label: item.state_name,
                              value: item.id,
                            }))}
                          />
                          <ErrorMessage name="stateId" component="div" className="text-red" />
                        </div>
                      </div>
                    </div>
                    {this.props.match.params.id !== undefined ? (
                      <div className="button_group mt-5 d-flex align-items-center gap-2 justify-content-end">
                        <button type="submit" className="update_button" disabled={isSubmitting}>
                          Update
                        </button>
                        <button
                          className="delete_button"
                          type="button"
                          onClick={(e) => {
                            this.checkDelete(e);
                          }}>
                          Delete
                        </button>
                        <button type="reset" className="reset_button" onClick={this.redirectAfterEdit}>
                          <Link to="/masters/taxation">
                            Reset
                          </Link>
                        </button>
                      </div>
                    ) : (
                      <div className="button_group mt-5 d-flex align-items-center gap-2 justify-content-end">
                        <button type="submit" className="add_button" disabled={isSubmitting}>
                          Add
                        </button>
                        <button type="reset" className="reset_button" onClick={this.redirectAfterEdit}>
                          Reset
                        </button>
                      </div>
                    )}
                  </div>
                </Form>
              </div>

              {/* <div className="unitFormContainerNew">
                <Form autoComplete="off" >
                  <div className="container">
                    <div className="row">
                      {clientAccess() &&
                        <div className="col-lg-6">
                          <div className="inputContainer col-lg-12 col-md-12">
                            <div className="row mb-3">
                              <label className="col-sm-4 col-form-label">
                                Client Group <span className="astrik">*</span>
                              </label>
                              <div className="col-sm-7">
                                <select
                              name="clientGroup"
                              onInputChange={this.handleChange}
                              onChange={this.handleChangeLandlordGroup, "change_client_group"}
                              options={this.state.LandlordGroups.map(
                                (item) => ({
                                  label: item.group_name,
                                  value: item.id,
                                })
                              )}
                            />

                                <Select
                                  className="basic-single custom-select-style"
                              classNamePrefix="custom-select-style-inner"
                                  name="clientGroup"
                                  //onInputChange={this.handleChange}
                                  onChange={(e) => {
                                    this.handleChangeLandlordGroup(
                                      e,
                                      "change_client_group"
                                    );
                                  }}
                                  value={{
                                    label: this.state.initialValues.groupName,
                                    value: this.state.initialValues.groupId,
                                  }}
                                  options={this.state.LandlordGroups.map(
                                    (item) => ({
                                      label: item.group_name,
                                      value: item.id,
                                    })
                                  )}
                                />

                                <ErrorMessage
                                  name="clientGroup"
                                  component="div"
                                  className="text-red"
                                />
                              </div>
                            </div>
                          </div>
                        </div>}
                      {clientAccess() &&
                        <div className="col-lg-6">
                          <div className="inputContainer col-lg-12 col-md-12">
                            <div className="row mb-3">
                              <label className="col-sm-4 col-form-label">
                                Client Name <span className="astrik">*</span>
                              </label>
                              <div className="col-sm-7">
                                <Select
                                  className="basic-single custom-select-style"
                              classNamePrefix="custom-select-style-inner"
                                  name="clientName"
                                  onChange={(e) => {
                                    this.handleChangeLandlordGroup(
                                      e,
                                      "change_client_name"
                                    );
                                  }}
                                  value={{
                                    label: this.state.initialValues.clientName,
                                    value: this.state.initialValues.clientId,
                                  }}
                                  options={this.state.clientList.map((item) => ({
                                    label: item.client_name,
                                    value: item.id,
                                  }))}
                                />
                                <ErrorMessage
                                  name="clientName"
                                  component="div"
                                  className="text-red"
                                />
                              </div>
                            </div>
                          </div>
                        </div>}
                      <div className="col-lg-6">
                        <div className="inputContainer col-lg-12 col-md-12">
                          <div className="row mb-3">
                            <label className="col-sm-4 col-form-label">
                              Rate Type <span className="astrik">*</span>
                            </label>
                            <div className="col-sm-7">

                              <Select
                                className="basic-single custom-select-style"
                                classNamePrefix="custom-select-style-inner"
                                name="rate_type"
                                onInputChange={this.handleChange}
                                onChange={(e) => {
                                  this.handleChangeLandlordGroup(
                                    e,
                                    "rate"
                                  );
                                }}
                                value={{
                                  label: this.state.initialValues.rateTypeTitle,
                                  value: this.state.initialValues.rateTypeId,
                                }}
                                options={this.state.rateTypes.map(
                                  (item) => ({
                                    label: item.title,
                                    value: item.title,
                                  })
                                )}
                              />

                              <ErrorMessage
                                name="rate_type"
                                component="div"
                                className="text-red"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="inputContainer col-lg-12 col-md-12">
                          <div className="row mb-3">
                            <label className="col-sm-4 col-form-label">
                              Charge Type<span className="astrik">*</span>
                            </label>
                            <div className="col-sm-7">

                              <Select
                                className="basic-single custom-select-style"
                                classNamePrefix="custom-select-style-inner"
                                name="charge_type"
                                onInputChange={this.handleChange}
                                onChange={(e) => {
                                  this.handleChangeLandlordGroup(
                                    e,
                                    "charge"
                                  );
                                }}
                                value={{
                                  label: this.state.initialValues.chargeTypeId,
                                  value: this.state.initialValues.chargeTypeTitle,
                                }}
                                options={this.state.chargeTypes.map(
                                  (item) => ({
                                    label: item.title,
                                    value: item.title,
                                  })
                                )}
                              />

                              <ErrorMessage
                                name="charge_type"
                                component="div"
                                className="text-red"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="inputContainer col-lg-12 col-md-12">
                          <div className="row mb-3">
                            <label className="col-sm-4 col-form-label">
                              From Date <span className="astrik">*</span>
                            </label>
                            <div className="col-sm-7">
                              <Field type="date" name="from_date" />
                              <ErrorMessage
                                name="from_date"
                                component="div"
                                className="text-red"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="inputContainer col-lg-12 col-md-12">
                          <div className="row mb-3">
                            <label className="col-sm-4 col-form-label">
                              To Date <span className="astrik">*</span>
                            </label>
                            <div className="col-sm-7">
                              <Field type="date" name="to_date" />
                              <ErrorMessage
                                name="to_date"
                                component="div"
                                className="text-red"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="inputContainer col-lg-12 col-md-12">
                          <div className="row mb-3">
                            <label className="col-sm-4 col-form-label">
                              Rate <span className="astrik">*</span>
                            </label>
                            <div className="col-sm-7">
                              <Field type="text" name="rate" />
                              <ErrorMessage
                                name="rate"
                                component="div"
                                className="text-red"
                              />
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-lg-6">
                        <div className="inputContainer col-lg-12 col-md-12">
                          <div className="row mb-3">
                            <label className="col-sm-4 col-form-label">
                              State
                            </label>
                            <div className="col-sm-7">
                              <Select
                                className="basic-single custom-select-style"
                                classNamePrefix="custom-select-style-inner"
                                name="stateId"
                                onChange={(e) => {
                                  //handleChange(e);
                                  this.valueChange(e, "change_state");
                                }}
                                value={this.state.stateSelected}
                                options={this.state.states.map((item) => ({
                                  label: item.state_name,
                                  value: item.id,
                                }))}
                              />

                              <ErrorMessage
                                name="stateId"
                                component="div"
                                className="text-red"
                              />
                            </div>
                          </div>
                        </div>
                      </div>


                      <div className="col-lg-6">
                      <div className="inputContainer col-lg-12 col-md-12">
                        <div className="row mb-3">
                          <label className="col-sm-4 col-form-label">
                            State <span className="astrik">*</span>
                          </label>
                          <div className="col-sm-7">
                            <Field type="text" name="rate" />
                            <ErrorMessage
                              name="rate"
                              component="div"
                              className="text-red"
                            />
                          </div>
                        </div>
                      </div>
                    </div>



                    </div>
                    {this.props.match.params.id !== undefined ? (
                      <div className="row">
                        <div className="col-lg-6 offset-lg-6">
                          <div className="btnContainer">
                            <div>
                              <button type="submit" disabled={isSubmitting}>
                                Update
                              </button>
                              <button
                                type="button"
                                onClick={(e) => {
                                  this.checkDelete(e);
                                }}
                              >
                                Delete
                              </button>
                              <button type="reset" onClick={this.redirectAfterEdit}>
                                <Link to="/masters/taxation">
                                  Reset
                                </Link>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div className="row">
                        <div className="col-lg-6 offset-lg-6">
                          <div className="btnContainer">
                            <div>
                              <button type="submit">
                                Add
                              </button>
                              <button type="reset" onClick={this.redirectAfterEdit}>
                                Reset
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </Form>
              </div> */}
            </>
          )}
        </Formik>
        <PopupMessage
          open={this.state.messsagePopup}
          content={this.state.popupContent}
          redirectAfterSave={this.redirectAfterSave}
        />
        <Popup open={this.state.delete} position="top center">
          {(close) => (
            <div>
              "Are you sure you want to delete this item?"
              <a className="close" onClick={this.redirectToClose}>
                &times;
              </a>
              <div>
                <button type="button" onClick={this.redirectToDelete}>
                  Yes
                </button>
              </div>
            </div>
          )}
        </Popup>
        <Popup open={this.state.popupalertMessage} position="top center">
          {(close) => (
            <div>
              {this.state.popupMessageContent}
              <a className="close" onClick={this.redirectToClose}>
                &times;
              </a>
            </div>
          )}
        </Popup>
        <TaxationTable />
      </>
    );
  }
}

export default withRouter(List);
